import { Box, Card, Divider } from '@zillow/constellation-10';
import { Bone } from '@zg-rentals/satellite-components';
import SkeletonContainer from '../SkeletonContainer';
import useConsistentCancellationsUiEnabled from '../../hooks/useConsistentCancellationsUiEnabled';
import { redesignedCardStyles, redesignedSectionStyles } from './styles';

export default function TourStatusCardSkeleton({ showStackedView = false }) {
  const isConsistentCancellationsUiEnabled = useConsistentCancellationsUiEnabled();

  if (isConsistentCancellationsUiEnabled) {
    return (
      <SkeletonContainer>
        <Card elevated={false} css={redesignedCardStyles}>
          <Box css={redesignedSectionStyles}>
            <Bone type="line" />
            <Bone type="line" css={{ marginTop: 'default' }} />
            {showStackedView && <Bone type="line" css={{ marginTop: 'default' }} />}
          </Box>
          <Divider />
          <Box css={redesignedSectionStyles}>
            <Bone type="line" />
          </Box>
        </Card>
      </SkeletonContainer>
    );
  }

  return (
    <SkeletonContainer>
      <Card
        elevated={false}
        css={{
          borderLeftWidth: '3px',
          // oxlint-disable-next-line constellation/prefer-semantic-tokens -- pre-existing base token; ESLint treated this as warn-level, not blocking
          borderLeftColor: 'gray.300',
          display: 'flex',
          flexDirection: 'column',
          flexFlow: 'column wrap',
          paddingLeft: 'loose',
          paddingRight: 'loose',
        }}
      >
        <Bone type="line" />
        <Bone type="line" css={{ marginTop: 'default' }} />
        {showStackedView && <Bone type="line" css={{ marginTop: 'default' }} />}
      </Card>
    </SkeletonContainer>
  );
}
